import React from "react";
import Spinner from "react-bootstrap/esm/Spinner";

const InlineSpinner = ({custom_class}) => {
    return (
        <div
            className={custom_class ? custom_class : ""}
        >
            <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
            </Spinner>
        </div>
    )
}

export default InlineSpinner;